import React from 'react';
import { useLocation } from 'react-router-dom';
import { authHeader } from '../../_heleper/auth-header';
import { url } from '../../api/apiurl';
import { createVideoApi } from './api';
import VideoSupport from './VideoSupport';
import CustomerCallNotification from './CustomerCallNotification';

const api = createVideoApi(process.env.REACT_APP_VIDEO_SUPPORT_API_URL || (process.env.NODE_ENV === 'development' ? 'http://localhost:4000/v1' : url), authHeader);
export default function VideoSupportPage() {
  return <VideoSupport api={api} signInUrl="/account/registor" />;
}
const hasSession = () => Boolean(authHeader().Authorization);
export function VideoSupportLauncher() {
  const location = useLocation();
  return <><CustomerCallNotification api={api} pathname={location.pathname} hasSession={hasSession} />{location.pathname !== '/video-support' && <a className="vs-launcher" href="/video-support"><span aria-hidden="true">◉</span> Free Video Call</a>}</>;
}
